import { store, getContext } from '@wordpress/interactivity';

/**
 * Checks to see if the browser is on a mobile device.
 *
 * Using feature detection instead of userAgent to determine if the device supports touch events.
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/Browser_detection_using_the_user_agent#alternatives_to_ua_sniffing
 *
 * @return {boolean} whether the device supports touch events
 */
function hasTouchSupport() {
  return 'ontouchstart' in window || window.navigator.maxTouchPoints > 0;
}

/**
 * Adds share interactivity to the store.
 */
const { state } = store('bigbite-share-button', {
  actions: {
    *share({ target }) {
      const data = {
        url: target.dataset.url,
        title: target.dataset.title,
        text: target.dataset.text,
      };

      if (!data.url) {
        return;
      }

      if (hasTouchSupport() && !!navigator.share && navigator.canShare(data)) {
        try {
          yield navigator.share(data);
        } catch (error) {
          if (error.name !== 'AbortError') {
            // eslint-disable-next-line no-console
            console.error('Error sharing:', error);
          }
        }
      } else {
        try {
          yield navigator.clipboard.writeText(data?.url);

          const context = getContext();

          context.text = state.copied_text;

          setTimeout(() => {
            context.text = state.default_text;
          }, 1500);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error copying url:', error);
        }
      }
    },
  },
});
